var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwingH(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_319994627358759193459031277966844725414",
    d: "M13.646 0c4.975-.048 9.478 3.006 11.293 7.726l.7-1.07 1.678 1.117-1.764 2.697c-.24.367-.685.54-1.103.427l-2.916-.781.528-1.972.878.235c-1.564-3.813-5.233-6.276-9.215-6.338h-.133c-3.982.062-7.65 2.525-9.215 6.338l.878-.235.528 1.972-2.916.781c-.418.112-.862-.06-1.103-.427L0 7.773l1.677-1.118.7 1.071C4.157 3.103 8.513.08 13.365.002z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_228723735261728672759680550250344449349",
    d: "M-2.763 -10.567H29.696000000000005V23.054000000000002H-2.763z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_62055218578810271593524354550293688845",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-264 -367) translate(248 359) translate(16 8) translate(2.341 9.756)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_107241917863416402803749001749974125089",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_319994627358759193459031277966844725414"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#hinava_random_uuid_319994627358759193459031277966844725414"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_107241917863416402803749001749974125089)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_228723735261728672759680550250344449349"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_62055218578810271593524354550293688845)",
    xlinkHref: "#hinava_random_uuid_228723735261728672759680550250344449349"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwingH);
export default __webpack_public_path__ + "static/media/swing-h.e85f3effb74095cad88adf6d344899c1.svg";
export { ForwardRef as ReactComponent };